import React, { Component, Fragment } from 'react';

import api from '../../api/api';

import Modal from "./Modal"
import ModalEstado from "./ModalEstado"

import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable"


class EscribaniaList extends Component {
    
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Domicilio",
                    id: "apellidoNombreN",
                    accessor: d => d.apellidoNombreN,
                    show: true,
                },
                {
                    Header: "Contacto",
                    id: "contactoN",
                    accessor: d => d.contactoN,
                    show: true,
                },
                {
                    Header: "Loteo",
                    id: "loteoNombreN",
                    accessor: d => d.loteoNombreN,
                    show: true,
                },
                {
                    Header: "Lote",
                    id: "loteN",
                    accessor: d => d.loteN,
                    show: true,
                },
                {
                    Header: "Manzana",
                    id: "manzanaN",
                    accessor: d => d.manzanaN,
                    show: true,
                },      
                {
                    Header: "Estado",
                    id: "estado",
                    accessor: d => <Fragment>
                                        { d.estado !== null &&
                                            <span className={'ui-status-pill ' + (d.estado === 2 ? 'is-success' : 'is-warning')}>
                                                {(d.estado === 2) ? 'Listo' : 'Pendiente'}
                                            </span>
                                        }
                                    </Fragment>,
                    width: 120,
                    Filter: ({ filter, onChange }) =>
                        <select
                            value={filter ? filter.value : ''}
                            onChange={e => onChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="1">Pendiente</option>
                            <option value="2">Listo</option>
                        </select>,
                    show: true,
                },       
                {
                    Header: "Reporte",
                    id: "contacto",
                    width: 130,
                    accessor: d => <a className="ui-table-link" href={(api.escribania.reporte).replace('$id', d.id)} target='_blank' rel="noopener noreferrer">Descargar</a>,
                    show: true,
                },     
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;

        return (
            <ParadigmaTable
                buttons={[
                    /*{
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'proveedores_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'proveedores_edit',
                    },*/
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'escribania_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'escribania_delete',
                    },
                    {
                        edit: true,
                        component: (props) => <ModalEstado {...props} action="EDIT" />,
                        permission: 'escribania_edit',
                    },
                ]}
                depth={1}
                apiUrl={api.escribania.escribania}
                columns={this.state.columns}
                exportUrl={api.escribania.escribania}
                title={"Escribania"}
            />
        );
    }
}

export default EscribaniaList;



// WEBPACK FOOTER //
// ./src/views/Escribania/EscribaniaList.js